import { Box, Button, TextField, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { FormProvider, useFieldArray, useForm } from "react-hook-form";
import CustomDialog from "../../../components/dialog";
import { RHFTextField } from "../../../components/hook-form";
import { useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import pemdingLeaguesIcon from "../../../styles/images/pendingLeagueIcon.svg";
import activeLeagueIcon from "../../../styles/images/activeLeagueIcon.svg";
import { useParams } from "react-router-dom";
import addSeasonSchema from "../../../schemas/addSeason";
import linkIcon from "../../../styles/images/linkIcon.svg";
import PlayersTable from "./playersTable";
import SeasonTable from "./seasonTable";
import {
  getLeagueParticipants,
  getInviteLink,
  getLeagueThemes,
  getLeagueAcceptanceStatus,
  updateLeague,
} from "../../../services/leagues";
import toast from "react-hot-toast";
import moment from "moment";
import CreateSeasonForm from "./CreateSeasonForm";
import { addSeason } from "../../../services/season";

export default function LeagueByID() {
  const [createSeason, setCreateSeason] = useState(false);
  const [sendEmail, setSendEmail] = useState(false);
  const { id: league_id } = useParams();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refetch, setRefetch] = useState(false);
  const [copying, setCopying] = useState(false);
  const [themes, setThemes] = useState([]);
  const [acceptanceStatus, setAcceptanceStatus] = useState(true);
  const [editLeagueName, setEditLeagueName] = useState(false);
  const [editLeagueDescription, setEditLeagueDescription] = useState(false);
  const [updatedLeagueName, setUpdatedLeagueName] = useState("");
  const [updatedLeagueDescription, setUpdatedLeagueDescription] = useState("");

  const {
    control,
    getValues,
    watch,
    handleSubmit,
    setValue,
    formState: { errors },
    ...methods
  } = useForm({
    resolver: yupResolver(addSeasonSchema),
    defaultValues: {
      season_name: "",
      weeks_for_season_games: "",
      week: [],
    },
  });

  const onSubmit = async (data) => {
    console.log("data === ", data);
    const objData = {
      league_id: parseInt(league_id),
      season_name: data.season_name,
      start_date: moment(data.start_date).format("YYYY-MM-DD"),
      weeks_for_season_games: data.weeks_for_season_games,
      themes: data && data.week.map((ele, idx) => ({
        week_number: idx + 1,
        theme_id: parseInt(ele.theme_id),
        is_playoffs: ele.is_playoffs,
        is_finals: ele.is_finals,
      })),
    };
    console.log("objData === ", objData);

    try {
      setLoading(true);
      let res = await addSeason(objData);
      toast.success(res.message);
      setLoading(false);
      setCreateSeason(false);
      setRefetch(!refetch);
      methods.reset();
    } catch (err) {
      console.log("err === ", err);
      toast.error(err);
      setLoading(false);
    }
  };
  const handleSendEmail = () => {
    setSendEmail(false);
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      console.log("in try === ", league_id);
      const response = await getLeagueParticipants(league_id);

      console.log("response get participants == ", response.data.participants);
      setData(response.data);
      // setTotalRecords(response.data.conducted_leagues.length);
      // setData([
      //   {
      //     id: 1,
      //     player_number: 1,
      //     name: "Player 1",
      //     email: "player1@gmail.com",
      //   },
      //   {
      //     id: 2,
      //     player_number: 2,
      //     name: "Player 2",
      //     email: "player2@gmail.com",
      //   },
      // ]);
    } catch (err) {
      // setError("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };
  const getAllLeagueThemes = async () => {
    try {

      const response = await getLeagueThemes();
      console.log("response get themes == getAllLeagueThemes", response);
      setThemes(response?.data ? response?.data?.themes : []);
    } catch (err) {
      console.log("err === getAllLeagueThemes", err);
      setThemes([])
    }
  };
  const fetchAcceptanceStatus = async () => {
    const response = await getLeagueAcceptanceStatus(league_id);
    setAcceptanceStatus(response.data.is_accepting_users);
  };

  useEffect(() => {
    fetchData();
    getAllLeagueThemes();
    fetchAcceptanceStatus();
  }, []);

  const handleCopyInviteLink = async () => {
    try {
      setCopying(true);
      const response = await getInviteLink(league_id);

      // Extract token from the response
      const token = response.data.invite_link.split("token=")[1];

      // Construct URL with correct query parameters
      const inviteLink = `${window.location.origin}/my_leagues?league_id=${league_id}&token=${token}`;

      await navigator.clipboard.writeText(inviteLink);
      toast.success("Invite link copied to clipboard!");
    } catch (error) {
      console.error("Error copying invite link:", error);
      toast.error(error?.message || "Failed to copy invite link");
    } finally {
      setCopying(false);
    }
  };

  const { fields, append, remove, move } = useFieldArray({
    control,
    name: "week",
  });
  const weeksForSeasonGames = watch("weeks_for_season_games");

  useEffect(() => {
    // Remove all existing fields
    remove();

    if (weeksForSeasonGames > 0) {
      // Add new fields based on the number of weeks
      for (let i = 0; i < weeksForSeasonGames; i++) {
        append({
          id: i + 1,
          theme_id: "",
          week_number: i + 1,
          is_playoffs: false,
          is_finals: false,
        });
      }
      append({
        id: weeksForSeasonGames + 1,
        theme_id: "",
        week_number: weeksForSeasonGames + 1,
        is_playoffs: true,
        is_finals: false,
      });
      append({
        id: weeksForSeasonGames + 2,
        theme_id: "",
        week_number: weeksForSeasonGames + 2,
        is_playoffs: true,
        is_finals: true,
      });
    }
  }, [weeksForSeasonGames, append, remove]);

  // Assuming themes have an end_date property
  // const calculateWeekEndDate = (startDate, weekNumber) => {
  //   return moment(startDate).add(weekNumber * 7, "days");
  // };

  // const filteredThemes = (weekEndDate) => {
  //   // return themes.filter((theme) =>
  //   //   moment(theme.end_date).isAfter(weekEndDate)
  //   // );
  //   return themes;
  // };

  const handleEditLeagueName = () => {
    setEditLeagueName(true);
    setUpdatedLeagueName(data?.league_name);
  };

  const handleUpdateLeagueName = (e) => {
    setUpdatedLeagueName(e.target.value);
  };

  const handleKeydowLeagueName = async (e) => {
    if (e.key === "Enter") {
      const res = await updateLeague(league_id, { league_name: updatedLeagueName });
      toast.success(res.message);
      setEditLeagueName(false);
      setData({ ...data, league_name: res.league_name });
    }
  };
  const handleEditLeagueDescription = () => {
    setEditLeagueDescription(true);
    setUpdatedLeagueDescription(data?.league_description);
  };

  const handleKeydowLeagueDescription = async (e) => {
    if (e.key === "Enter") {
      const res = await updateLeague(league_id, { description: updatedLeagueDescription });
      toast.success(res.message);
      setEditLeagueDescription(false);
      setData({ ...data, league_description: res.description });
    }
  };

  return (
    <div>
      <div className="league-header">
        <img
          className="league-header-image"
          src={
            data?.league_status === "Upcoming"
              ? pemdingLeaguesIcon
              : activeLeagueIcon
          }
          alt="league"
        />
        <div className="league-header-content">
          {editLeagueName ?
            <TextField
              autoFocus
              className="league-name-input"
              value={updatedLeagueName}
              onChange={(e) =>
                setUpdatedLeagueName(e.target.value)
              }
              onKeyDown={handleKeydowLeagueName}
              onBlur={() => setEditLeagueName(false)} />
            :
            <p className="heading-title" onClick={handleEditLeagueName}>{data?.league_name}</p>
          }
          {editLeagueDescription ?
            <TextField
              autoFocus
              className="league-description-input"
              multiline
              rows={4}
              fullWidth
              value={updatedLeagueDescription}
              onChange={(e) =>
                setUpdatedLeagueDescription(e.target.value)
              }
              onKeyDown={handleKeydowLeagueDescription}
              onBlur={() => setEditLeagueDescription(false)}
              sx={{
                marginTop: '1rem',
                '& .MuiOutlinedInput-root': {
                  '& textarea': {
                    fontSize: '0.9rem',
                    lineHeight: '1.5'
                  }
                }
              }}
            />
            :
            <Typography
              variant="body1"
              onClick={handleEditLeagueDescription}
              sx={{
                marginTop: '1rem',
                whiteSpace: 'pre-wrap',
                fontSize: '0.9rem',
                lineHeight: '1.5',
                color: 'text.secondary',
                cursor: 'pointer',
                '&:hover': {
                  color: 'text.primary'
                }
              }}
            >
              {data?.league_description || 'No description available'}
            </Typography>
          }
        </div>
        {/* {data?.league_status === "Upcoming" && ( */}
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          className="button-primary league-header-button"
          onClick={() => setCreateSeason(true)}
        >
          Season
        </Button>
        {/* )} */}
      </div>

      {/* {data?.league_status !== "Upcoming" && ( */}
      <div>
        <SeasonTable refetch={refetch} setRefetch={setRefetch} />
      </div>
      {/* )} */}

      <div className="league-header mt-4">
        <div className="league-header-content">
          <p className="heading-title-players">Players</p>
        </div>
        {data?.league_status === "Upcoming" && (
          <div>
            {/* <Button
              variant="contained"
              className="button-primary email-all-players-button"
              onClick={() => setSendEmail(true)}
            >
              Email All Players
            </Button> */}

            <Button
              variant="contained"
              startIcon={
                <img
                  src={linkIcon}
                  style={{ opacity: acceptanceStatus ? 1 : 0.5 }}
                  alt="link"
                />
              }
              className="button-primary copy-invite-link-button"
              onClick={handleCopyInviteLink}
              disabled={copying || !acceptanceStatus}
            >
              {copying ? "Copying..." : "Copy Invite Link"}
            </Button>
          </div>
        )}
      </div>

      <Box mt={1}>
        <PlayersTable
          data={
            data?.participants?.map((ele, idx) => ({ id: idx + 1, ...ele })) || []
          }
        />
      </Box>
      {createSeason && (
        <CreateSeasonForm
          methods={methods}
          control={control}
          onSubmit={onSubmit}
          loading={loading}
          setCreateSeason={setCreateSeason}
          themes={themes}
          fields={fields}
          watch={watch}
          // calculateWeekEndDate={calculateWeekEndDate}
          filteredThemes={themes}
          handleSubmit={handleSubmit}
        />
      )}
      <CustomDialog
        open={sendEmail}
        handleClose={() => setSendEmail(false)}
        handleSubmit={handleSendEmail}
        buttonTxt="Send"
        title="Confirmation: Send Email"
        cancelBtn={true}
        alignActions={"center"}
        fullWidth={true}
      >
        <Typography className="align_text_center mb-2">
          Are you sure you want to send email to all players?
        </Typography>
      </CustomDialog>
    </div>
  );
}
